import { useState, useEffect } from 'react';
import axios from 'axios';

import { useParams } from 'react-router-dom';
import { formatDate, formatRupiah, formatTime } from '../../../helper/helper';
import { FaEnvelope, FaPrint } from 'react-icons/fa';
import PanelTop from '../../../component/Admin/PanelTopSecond';
import WebsiteLogo from '../../../component/WebsiteLogo';
import { useWebsiteSettings } from '../../../hooks/useWebsiteSettings';

const PaymentBill = ({ data }) => {
    const { trxID } = useParams();
    const { settings } = useWebsiteSettings(data?.token);
    const [item, setItem] = useState()
    const [isSending, setIsSending] = useState(false)
    const header = {
        headers: { 'Authorization': `Bearer ${data.token}` }
    }
    useEffect(() => {
        const getItem = async () => {
            await axios.get(`api/payment/transaction/${trxID}`, header)
                .then((response) => {
                    setItem(response.data)
                })
                .catch((e) => {

                })
        }
        getItem()
        // eslint-disable-next-line
    }, [trxID])

    const handleSendEmail = async () => {
        const customer = {
            customerName: item.customerName,
            customerEmail: item.customerEmail,
            customerPhone: item.customerPhone,
            articleName: item.articleName,
            customerAddress: item.customerAddress,
            paymentName: item.paymentName,
            trxID: item.trxID,
            amount: item.amount,
            createAt: item.createAt,
        }
        try {
            setIsSending(true)
            await axios.post(`api/payment/sendMail`, customer, header)
            alert('Email berhasil dikirim')
        } catch (error) {
            alert('Gagal mengirim email')
            console.error(error)
        } finally {
            setIsSending(false)
        }
    }

    return (
        <>
            <PanelTop link={`/admin/payment`} title={"DETAIL Billing"} />
            <div id="print-area" className="w-full bg-white   lg:shadow-xl  xl:shadow-xl print:transform print:scale-90">
                <header className="flex flex-col items-center px-8 pt-8 text-lg text-center bg-white border-t-8 border-primary md:block lg:block xl:block print:block md:items-start lg:items-start xl:items-start print:items-start md:text-left lg:text-left xl:text-left print:text-left print:pt-0 print:px-2 md:relative lg:relative xl:relative print:relative">
                    <WebsiteLogo
                        token={data.token}
                        alt="Logo"
                        className="w-3/6 h-auto md:w-1/4 lg:ml-12 xl:ml-12 print:px-0 print:py-0 object-contain object-left"
                    />
                    <div className="flex flex-row mt-4 mb-2 ml-0 text-2xl font-bold md:text-3xl lg:text-4xl xl:text-4xl print:text-2xl lg:ml-12 xl:ml-12">INVOICE
                        <div className="text-primary">
                            <span className="mr-4 text-sm">■ </span> #
                        </div>
                        <span id="invoice_id" className="text-gray-500">{item?.trxID}</span>
                    </div>
                    <div className="flex flex-col lg:ml-12 xl:ml-12 print:text-sm">
                        <span>Issue date: {formatDate(item?.createAt)}</span>

                    </div>
                    <div className="px-8 py-2 mt-16 text-3xl font-bold text-primary border-4 border-primary border-dotted md:absolute md:right-0 md:top-0 md:mr-12 lg:absolute lg:right-0 lg:top-0 xl:absolute xl:right-0 xl:top-0 print:absolute print:right-0 print:top-0 lg:mr-20 xl:mr-20 print:mr-2 print:mt-8">UNPAID</div>
                    <div className="flex flex-col m-12 text-center lg:m-12 md:flex-none md:text-left md:relative md:m-0 md:mt-16 lg:flex-none lg:text-left lg:relative xl:flex-none xl:text-left xl:relative print:flex-none print:text-left print:relative print:m-0 print:mt-6 print:text-sm">
                        <div className=" underline font-bold ">PAYMENT METHODS </div>
                        <ul className=' ml-4'>
                            <li className=' list-disc'>
                                <div className=' font-semibold'>
                                    Transfer Bank
                                </div>
                                <div className=' '>
                                    <div>Bank Name : {item?.bank}</div>
                                    <div>Rekening Number : {item?.rekening_number}</div>
                                    <div>An. : {item?.owner}</div>
                                </div>
                            </li>
                        </ul>

                        <div className="flex flex-col md:absolute md:right-0 md:text-right lg:absolute lg:right-0 lg:text-right print:absolute print:right-0 print:text-right">
                            <span className="  font-bold underline ">CUSTOMER </span>
                            <span id="person-name" className="font-medium">{item?.customerName}</span>
                            <span id="person-phone">{item?.customerPhone}</span>
                            <span id="person-mail">{item?.customerEmail}</span>
                            <span id="person-address">{item?.customerAddress}</span>

                        </div>
                    </div>
                </header>
                <hr className="border-gray-300 md:mt-8 " />

                <div>
                    <div id="content" className="flex justify-center md:p-8 lg:p-20 xl:p-20 print:mt-8 print:p-2">
                        <table className="w-full text-left table-auto print:text-sm" id="table-items">
                            <thead>

                                <tr className=" text-white bg-gray-700 print:bg-primary print:text-black">
                                    <th className="border px-4 py-2">Item
                                    </th>
                                    <th className="border px-4 py-2 text-right">Qty</th>
                                    <th className=" border px-4 py-2 text-right">Unit Price</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr className="bg-gray-100 print:bg-gray-100">
                                    <td className="px-4 py-2 border ">
                                        <div className=' print:font-semibold'>
                                            {item?.paymentName}
                                        </div>
                                        <div className="flex flex-col ml-4 text-xs ">
                                            <p className="flex items-center italic ">{item?.articleName}</p>

                                        </div>
                                    </td>
                                    <td className="px-4 py-2 text-right border tabular-nums slashed-zero">1</td>
                                    <td className="px-4 py-2 text-right border tabular-nums slashed-zero print:w-28">Rp. {formatRupiah(item?.amount)}</td>
                                </tr>

                                <tr className="text-white bg-gray-700 print:bg-gray-300 print:text-black" >
                                    <td className="px-4 py-2 font-extrabold text-right border">Total</td>
                                    <td className="px-4 py-2 font-extrabold text-right border">1</td>
                                    <td className="px-4 py-2 text-right border tabular-nums slashed-zero">Rp. {formatRupiah(item?.amount)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <footer className="flex flex-col items-center justify-center pb-20 leading-loose text-white bg-gray-700 print:bg-white print:pb-0">
                    <span className="mt-4 text-xs print:mt-0">Invoice generated on {formatDate(item?.createAt)} {formatTime(item?.createAt)}</span>
                    <span className="mt-4 text-base print:text-xs">{settings.footerText}</span>
                </footer>
            </div>
            <div className="w-full"></div>
            <div className=" print:hidden w-full space-x-4 flex justify-start">
                <button className="no-print w-full flex justify-center bg-white space-x-2  items-center p-4 my-4  border-2 border-[#ffffff] text-primary text-2xl rounded " title="Cetak" onClick={() => window.print()} > <FaPrint />  <span>Cetak</span></button>
                <button
                    className="no-print w-full flex justify-center bg-white space-x-2  items-center p-4 my-4  border-2 border-[#ffffff] text-primary text-2xl rounded "
                    title="Kirim Email"
                    onClick={handleSendEmail}
                    disabled={isSending}
                >
                    <FaEnvelope />
                    <span>{isSending ? 'Mengirim...' : 'Kirim'}</span>
                </button>
            </div>
        </>
    );
};

export default PaymentBill;